import React, { useState } from "react";
import moment from "moment";
import noteIcon1 from "../../../../../../../Assets/images/note-icon1.svg";
import noteIcon2 from "../../../../../../../Assets/images/note-icon2.png";
import editIcon from "../../../../../../../Assets/images/edit-icon.svg";
import deleteIcon from "../../../../../../../Assets/images/delete-icon.svg";
import apiClient from "../../../../../../../Config/apiClient";
import { showSuccessToast, showErrorToast } from "../../../../../../../Context/Toaster/Toaster";
import ConfirmationModal from "../../../../../../../Components/ConfirmationBox/ConfirmationModal";
import AddEditNoteModal from "../../../NotesItems/AddNotesModal/AddNotesModal";
import { DATE_TIME_FORMAT } from "../../../../Utils/Constants";

const notesBaseUrl = process.env.REACT_APP_TC_NOTES_BASE_PATH;

const NotesTab = ({ notes = [], setNotes, selectedJobId  }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);

  const [showNoteModal, setShowNoteModal] = useState(false);
  const [editingNote, setEditingNote] = useState(null);

  const handleDeleteNote = async () => {
    if (!selectedNote) return;

    try {
      const response = await apiClient.delete(`${notesBaseUrl}/delete/${selectedNote.id}`);
      if (response.data.status === "SUCCESS") {
        showSuccessToast("Note deleted successfully");
        setNotes((prevNotes) => prevNotes.filter((note) => note.id !== selectedNote.id));
      } else {
        showErrorToast(response.data.message || "Failed to delete note");
      }
    } catch (error) {
      console.error(error);
      showErrorToast("An unexpected error occurred while deleting the note.");
    } finally {
      setShowDeleteModal(false);
      setSelectedNote(null);
    }
  };

  const handleSaveNote = async (noteData) => {
    try {
      if (editingNote) {
        const response = await apiClient.put(`${notesBaseUrl}/edit-notes/${editingNote.id}`, {
          description: noteData.description,
        });

        if (response.data.status === "SUCCESS") {
          setNotes((prev) =>
            prev.map((n) =>
              n.id === editingNote.id ? { ...n, description: noteData.description } : n
            )
          );
          showSuccessToast("Note updated successfully");
        } else {
          showErrorToast(response.data.message || "Failed to update note");
        }
      } else {
        const response = await apiClient.post(`${notesBaseUrl}/add-notes`, {
          job_id: noteData.jobId,
          description: noteData.description,
        });

        if (response.data.status === "SUCCESS") {
          const newNote = {
            id: response.data.data.id,
            description: noteData.description,
            created_at: new Date().toISOString(),
            created_by: response.data.data.created_by,
          };
          setNotes((prev) => [...prev, newNote]);
          showSuccessToast("Note added successfully");
        } else {
          showErrorToast(response.data.message || "Failed to add note");
        }
      }
    } catch (error) {
      console.error(error);
      showErrorToast("An error occurred while saving the note.");
    } finally {
      setShowNoteModal(false);
      setEditingNote(null);
    }
  };

  return (
    <div className="notes-inner">
      <div className="vrt-content notes-inner-split mt-0">
        {notes.length === 0 ? (
          <p className="text-muted text-center py-4">📝 No notes available</p>
        ) : (
          <div className="row" style={{ overflow: "auto" }}>
            {notes.map((note, index) => {
              const fullDate = moment.utc(note.created_at).local().format(DATE_TIME_FORMAT);
              const relativeTime = moment.utc(note.created_at).local().fromNow();
              const author = note.created_by;
              const description = note.description;

              return (
                <div className="col-md-12" key={index}>
                  <div className="modal-graybox note-box">
                    <p className="ago-text">{relativeTime}</p>
                    <div className="note-description">
                      <p className="note-des">{description}</p>
                    </div>
                    <div className="graybox-right mt-0 note-details">
                      <div className="graybox-split">
                        <img src={noteIcon1} alt="user" />
                        <p className="contact-text">{author}</p>
                      </div>
                      <div className="graybox-split">
                        <img src={noteIcon2} alt="date" />
                        <div className="d-flex flex-column">
                          <p className="contact-text">{fullDate}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <ConfirmationModal
        id="deleteNoteModal"
        show={showDeleteModal}
        title="Delete Note"
        message={`Are you sure you want to delete this note?`}
        confirmText="Yes"
        cancelText="Cancel"
        onConfirm={handleDeleteNote}
        onCancel={() => {
          setShowDeleteModal(false);
          setSelectedNote(null);
        }}
      />

      <AddEditNoteModal
        show={showNoteModal}
        onClose={() => setShowNoteModal(false)}
        onSave={(data) => handleSaveNote({ ...data, jobId: selectedJobId })}
        initialData={editingNote}
        jobId={selectedJobId}
      />
    </div>
  );
};

export default NotesTab;